import React from "react"
import { motion } from "framer-motion"
import { X } from "lucide-react"
import Avatar from "./Avatar"
import { MOTION_VARIANTS } from "./constants"

const ChatInfoSidebar = ({ chat, onClose }) => (
  <motion.div
    key="info"
    className="hidden lg:flex flex-col w-72 border-l border-slate-200 bg-white flex-shrink-0"
    variants={MOTION_VARIANTS.info}
    initial="hidden"
    animate="visible"
    exit="exit"
  >
    <div className="p-4 border-b border-slate-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-slate-900">Інформація</h3>
        <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded-full transition-colors">
          <X className="w-5 h-5 text-slate-500" />
        </button>
      </div>
      <div className="flex flex-col items-center">
        <Avatar className="w-20 h-20" />
        <h3 className="font-semibold text-lg text-slate-900 mt-3">{chat.name}</h3>
        <p className="text-sm text-slate-500">Company name</p>
        <p className={`text-sm mt-1 ${chat.online ? "text-green-500" : "text-slate-400"}`}>
          {chat.online ? "online" : "last seen recently"}
        </p>
      </div>
    </div>

    <div className="flex-1 overflow-y-auto p-4 space-y-4">
      <div>
        <h4 className="text-xs font-semibold text-slate-500 uppercase mb-2">Сповіщення</h4>
        <div className="bg-slate-50 rounded-lg p-3 flex items-center justify-between">
          <span className="text-sm text-slate-700">Вимкнути</span>
          <button className="w-10 h-6 bg-slate-300 rounded-full relative">
            <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full" />
          </button>
        </div>
      </div>
      <div>
        <h4 className="text-xs font-semibold text-slate-500 uppercase mb-2">Контакти</h4>
        <div className="bg-slate-50 rounded-lg p-3 space-y-2 text-sm">
          <div>
            <span className="text-slate-500">Телефон:</span>
            <span className="ml-2 text-slate-900">+38 044 333 44 33</span>
          </div>
          <div>
            <span className="text-slate-500">Режим:</span>
            <span className="ml-2 text-slate-900">10:00–18:00</span>
          </div>
        </div>
      </div>
    </div>
  </motion.div>
)

export default ChatInfoSidebar
